import tenantConstants from '@constants';
import Cookies from 'js-cookie';
import { cookieDomain } from './env';
import { getLoginPath } from './language';

export const removeCookies = () => {
  Cookies.remove(tenantConstants.AUTH_TOKEN_COOKIE_KEY, cookieDomain && { domain: cookieDomain, path: '/' });
  window.location.replace(getLoginPath());
};
